import { useCallback } from "react";
import { REDIRECT_AFTER_LOGIN_STORAGE_KEY } from "src/services/tokenRefresh.consts";

const useAuthRedirect = (isAuthenticated, location, loginWithRedirect) => useCallback(() => {
  if (!isAuthenticated) {
    const redirectPath = `${location.pathname}${location.search}${location.hash}`;
    sessionStorage.setItem(REDIRECT_AFTER_LOGIN_STORAGE_KEY, redirectPath);
    loginWithRedirect();
    return true;
  }
  return false;
}, [isAuthenticated, location, loginWithRedirect]);

export default useAuthRedirect;
